import { EVENT, EVENT_TYPE, CATEGORY } from '../resources/labels'

/**
 * Push event to dataLayer if clicked element has data-cta attribute
 * Usage: add data-cta="...action" to element
 * Requirement: the clicked element has a meaningfull inner text
 * @param {HTMLElement} target
 */
export default function cta({target: el}) {
    const isCTA = el.hasAttribute('data-cta');
    if (isCTA) {
        const action = `cta.${el.dataset.cta}.${EVENT.CLICK}`;
        dataLayer.push({
            events: {
                category: CATEGORY,
                action,
                label: el.innerText
            },
            event: `${EVENT_TYPE.INTERACTION}.${CATEGORY}.${action}`
        });
    }
}